import type { SearchDetailsRolesType } from '../../consts/search-details';
import { SEARCH_DETAILS_ROLES } from '../../consts/search-details';

export const getCustomerRoleBadge = (role: SearchDetailsRolesType) => {
  switch (role) {
    case SEARCH_DETAILS_ROLES.SUPER_ADMIN:
      return (
        <div className="flex justify-center items-center bg-blue-100 rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">
            {SEARCH_DETAILS_ROLES.SUPER_ADMIN}
          </span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.AGENTS:
      return (
        <div className="flex justify-center items-center bg-[#E1F0E8] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Agent</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.PARTNERS:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Partner</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.BRAND:
      return (
        <div className="flex justify-center items-center bg-[#F7E7E9] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Brand</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.AIR_TEAM:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Air Team</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.AGENCY:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Agency</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.COMMISSIONS:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Commissions</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.CLIENTS:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Guest Writer</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.SEO_CONSULTANTS:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">SEO Consultant</span>
        </div>
      );
    case SEARCH_DETAILS_ROLES.SUPPORT_STAFF:
      return (
        <div className="flex justify-center items-center bg-[#f6f8d0] rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-blue-900">Support Staff</span>
        </div>
      );
    default:
      return (
        <div className="flex justify-center items-center bg-red-500 rounded-[4px] px-[8px] py-[2px]">
          <span className="font-inter text-[12px] leading-[140%] text-black">{role}</span>
        </div>
      );
  }
};
